export default "https://cdn-gra.amplement.io/statics/images/placeholder/placeholderGroups@3x.png";